<template lang="pug">
   .loading {{ title }}
</template>

<script>
export default {
  name: 'loading',
  props: {
    title: {
      type: String,
      default: '正在加载...'
    }
  }
}
</script>

<style lang="scss" scoped>
.loading {
  float: left;
  width: 100%;
  text-align: center;
  margin-top: 40px;
  color: #8994A7;
  font-size: 16px;
}
/* 手机 */
@media screen and (max-width: 768px) {
  .loading{
    margin-top: 30px;
  }
}

/* 媒体查询（平板） */
@media screen and (min-width: 768px) and (max-width: 996px) {
 
}
</style>


// WEBPACK FOOTER //
// src/components/Loading.vue